import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { decryptData } from '../utils/crypt';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Directorioall() {
  const { csrfToken } = useCsrfToken();
  const [medicalDirectory, setMedicalDirectory] = useState([]);
  const [filterresults, setFilterresults] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // Debounce simple (200 ms)
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchTerm), 200);
    return () => clearTimeout(t);
  }, [searchTerm]);

  const removeAccents = (str) =>
    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL;
    const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;

    const domesticDecryptdata = (data) => decryptData(data, secretKey);

    const toSearchIndex = (item) => {
      const name = item.title || '';
      const specialty = item.specialty_title || '';
      const subs = Array.isArray(item.searchspecialties)
        ? item.searchspecialties.map((s) => (s && s.title) || '').join(' ')
        : '';
      const desc = item.description || '';
      return removeAccents(`${name} ${specialty} ${subs} ${desc}`.toLowerCase());
    };

    const transformData = (data) =>
      data.map((item) => {
        const phone = item.phone_1 ? domesticDecryptdata(item.phone_1) : '';
        const email = item.default_contact_email
          ? domesticDecryptdata(item.default_contact_email)
          : '';
        const searchIndex = toSearchIndex(item);

        return {
          id: item.id,
          image: `${API_URL}${item.primary_image}`,
          name: item.title,
          specialty: item.specialty_title,
          searchspecialties: item.searchspecialties, // [{title: "..."}]
          desc: item.description,
          contactemail: email,
          slug: item.slug,
          phone,
          social: [],
          searchIndex,
        };
      });

    if (csrfToken != null) {
      fetch(`${API_URL}/api/listings/directory`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'X-CSRF-TOKEN': csrfToken,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then((r) => r.json())
        .then((data) => setMedicalDirectory(transformData(data)))
        .catch((err) => console.error('Error fetching data:', err));
    }
  }, [csrfToken]);

  const filteredMedicalDirectory = useMemo(() => {
    if (!debouncedSearch.trim()) {
      setFilterresults(medicalDirectory.length);
      return medicalDirectory;
    }

    const normalized = removeAccents(debouncedSearch.toLowerCase()).trim();
    const tokens = normalized.split(/\s+/).filter(Boolean); // AND de tokens

    const results = medicalDirectory.filter((item) =>
      tokens.every((t) => item.searchIndex.includes(t))
    );

    setFilterresults(results.length);
    return results;
  }, [medicalDirectory, debouncedSearch]);

  return (
    <>
      <div className="row justify-content-center bg-inverted py-2">
        <div className="col-12 col-md-6">
          <input
            name="searchfield"
            type="text"
            className="form-control"
            placeholder="Buscar por nombre, especialidad o subespecialidad"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            aria-label="Campo de búsqueda universal"
          />
        </div>
      </div>

      <div className="row">
        {filteredMedicalDirectory.length > 0 ? (
          filteredMedicalDirectory.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
              <div className="directory position-relative overflow-hidden rounded p-2">
                <div className="position-relative">
                  <div className="card team team-primary bg-transparent text-center mb-5">
                    <div className="directory-image card-img team-image d-inline-block mx-auto rounded overflow-hidden">
                      <Link
                        to={`/directorio/${item.slug}`}
                        className="text-dark mb-0 title"
                      >
                        <img src={item.image} className="img-fluid" alt="" />
                      </Link>
                      <ul className="list-unstyled team-social mb-0">
                        {item.social.map((El, idx) => {
                          const Icon = El;
                          return (
                            <li className="mt-1" key={idx}>
                              <Link
                                to="#"
                                className="btn btn-sm btn-pills btn-icon"
                              >
                                <Icon className="icons fea-social" />
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>

                    <div className="content bg-white mx-4 p-2 z-1 rounded shadow">
                      <Link
                        to={`/directorio/${item.slug}`}
                        className="text-dark mb-0 title"
                      >
                        {item.name}
                      </Link>
                      <br />
                      <small className="text-muted mb-0 mt-1 fw-normal">
                        {item.specialty}
                      </small>

                      {/* {Array.isArray(item.searchspecialties) &&
                        item.searchspecialties.length > 0 && (
                          <div
                            className="d-flex flex-wrap gap-1 mt-2"
                            aria-label="Subespecialidades"
                          >
                            {item.searchspecialties.slice(0, 4).map((s, i) => (
                              <span
                                key={i}
                                className="badge bg-light text-dark border"
                                title={s && s.title}
                              >
                                {s && s.title}
                              </span>
                            ))}
                          </div>
                        )} */}

                      <a
                        className="btn btn-sm p-1 btn-dark mt-2 w-100"
                        href={`mailto:${item.contactemail}`}
                      >
                        Email
                      </a>
                      <a
                        className="btn btn-sm p-1 btn-dark mt-2 w-100"
                        href={`tel:${item.phone}`}
                      >
                        Llamar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center my-5">
            {filterresults >= 1 ? (
              <span>Cargando...</span>
            ) : (
              <span>
                No se encontraron resultados. Intente buscar por nombre, especialidad o subespecialidad.
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
}
